// filepath: src/services/axiosInstance.js

import axios from "axios";
import { store } from '../store/store';
import { logout } from '../store/authSlice';
import { authStorage } from "../utils/authStorage";

// Create a single reusable axios instance
const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api`, // backend API root
});

// Interceptor: automatically attach JWT token to every request
axiosInstance.interceptors.request.use((config) => {
    const token = authStorage.getToken();
    // Guard against sending literal 'null'/'undefined' strings
    if (token && token !== 'null' && token !== 'undefined') {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        delete config.headers.Authorization;
    }
    return config;
});

export default axiosInstance;

// Auto-logout on 401/403 (token expired/invalid)
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const message = String(error.response?.data?.message || error.response?.data?.error || "").toLowerCase();
        const shouldForceLogout =
            status === 401 ||
            (status === 403 && (
                message.includes("invalid or expired token")
                || message.includes("jwt")
                || message.includes("authorization")
            ));

        if (shouldForceLogout) {
            const path = window.location.pathname;
            // Only auto-logout and redirect if NOT already on a login page
            const isOnLoginPage =
                path === '/login' ||
                path === '/admin/login' ||
                path === '/superadmin/login' ||
                path === '/pos/login' ||
                path.endsWith('/login');
            if (!isOnLoginPage) {
                store.dispatch(logout());
                if (path.startsWith('/admin/')) {
                    window.location.href = '/admin/login';
                } else if (path.startsWith('/superadmin/')) {
                    window.location.href = '/superadmin/login';
                } else {
                    window.location.href = '/login';
                }
            }
        }
        return Promise.reject(error);
    }
);
